
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/data-grid/prompt-field-record",
      function () {
        return require("private-next-pages/x/api/data-grid/prompt-field-record.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/data-grid/prompt-field-record"])
      });
    }
  